import { Injectable } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { HttpClient } from '@angular/common/http';
import { WhosWho } from './whos-who';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WhosWhoService extends UrlService {
  constructor(private http: HttpClient) {
    super();
  }
  addWhosWho(payload: Partial<WhosWho[]>) {
    return this.http.post<WhosWho>(
      `${this.getwhoisWho}create`,
      { sections: payload },
      {
        observe: 'response',
      },
    );
  }
  getWhosWho(): Observable<{ data: WhosWho[] }> {
    return this.http.get<{ data: WhosWho[] }>(
      `${this.getwhoisWho}list?limit=0`,
    );
  }
  deleteWhosWho(id: number): Observable<any> {
    return this.http.delete(`${this.whoisWho}${id}`);
  }
  updateWhosWho(id: number, payload: WhosWho) {
    return this.http.patch<WhosWho>(`${this.whoisWho}${id}`, payload, {
      observe: 'response',
    });
  }
  updateImage(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('image', file);

    return this.http.put(`${this.whoisWho}${id}`, formData, {
      observe: 'response',
    });
  }
  getUpdatedDate(): Observable<{ lastUpdatedAt: string }> {
    return this.http.get<{ lastUpdatedAt: string }>(`${this.updatedDate}`);
  }
  getVistorcountDate(): Observable<{ totalUniqueVisitors: string }> {
    return this.http.get<{ totalUniqueVisitors: string }>(
      `${this.vistorCount}`,
    );
  }
}
